import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import CalendarModal from "./CalendarModal";
import './Calendar.css';

const Calendar = ({ events }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalDate, setModalDate] = useState(null);
  const [modalEvent, setModalEvent] = useState(null);

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleEventClick = (eventClickInfo) => {
    // The event ID now contains both the event ID and date timestamp
    // We can find by the full unique ID
    const event = events.find((e) => e.id === eventClickInfo.event.id);
    if (event) {
      setModalDate(eventClickInfo.event.start);
      setModalEvent(event);
      setModalIsOpen(true);
    }
  };

  const eventContent = (eventInfo) => {
    return (
      <div className="fc-event-content">
        <div className="fc-event-title">{eventInfo.event.title}</div>
        <div className="fc-event-time">
          {new Date(eventInfo.event.extendedProps.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
      </div>
    );
  };

  return (
    <div className="calendar-container">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={events}
        eventClick={handleEventClick}
        eventContent={eventContent}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek'
        }}
        buttonText={{
          today: 'Today',
          month: 'Month',
          week: 'Week'
        }}
        height="auto"
        eventTimeFormat={{
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }}
        eventDisplay="block"
        eventTextColor="#ffffff"
        contentHeight="auto"
        aspectRatio={1.35}
        handleWindowResize={true}
        windowResizeDelay={100}
        fixedWeekCount={false}
      />
      <CalendarModal
        isOpen={modalIsOpen}
        onClose={handleCloseModal}
        date={modalDate}
        event={modalEvent}
      />
    </div>
  );
};

export default Calendar;
